var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"integration-detail-card"},[_c('header',{staticClass:"integration-detail-card__header"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),(_vm.$slots.actions)?_c('div',{staticClass:"integration-detail-card__actions"},[_vm._t("actions")],2):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }